import { siteData } from '@/data/siteData';

export function Obituaries() {
  return (
    <section id="obituaries" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title">In Loving Memory</h2>
          <p className="section-subtitle">
            Geskikte Begrafnisdienste, want ons is hier vir jou!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {siteData.obituaries.map((obit) => (
            <div
              key={obit.id}
              className="card-hover bg-brand-light rounded-xl overflow-hidden border border-brand-navy/10"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={obit.image}
                  alt={obit.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-brand-navy/60" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-serif font-bold text-brand-navy mb-2">
                  {obit.name}
                </h3>
                <p className="text-sm text-brand-gold font-medium mb-4">{obit.dates}</p>
                <p className="text-brand-navy/70 text-sm mb-6 line-clamp-3">
                  {obit.tribute}
                </p>
                <div className="flex items-center gap-2 text-xs text-brand-navy/50 font-medium">
                  <span>{obit.serviceDate}</span>
                  <span className="h-3 w-px bg-brand-navy/30 mx-1" />
                  <span>{obit.serviceLocation}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-brand-navy/60 text-sm">
            Contact us for details on upcoming services and arrangements.
          </p>
        </div>
      </div>
    </section>
  );
}